import React, { useState, useEffect, useRef, useContext } from 'react';
import DatePicker from 'react-datepicker';
import './Templates.css';
import { FaTimes, FaEnvelope, FaStar, FaCar, FaAngleDown, FaCalendarAlt, FaClock, FaChevronLeft, FaChevronRight, FaCircle, FaSyncAlt, FaPalette, FaChevronDown, FaChevronUp, FaArrowLeft } from 'react-icons/fa';
import { useToast } from './hooks/ToastContext';
import { UnifiedDateTimePicker } from './common/UnifiedDateTimePicker';
import { AuthContext } from './Provider';
import { useTranslation } from 'react-i18next';


//---------------------EVENT-CARD-DETAIL-------------------
export function EventCardDetail({ icon, text }) {
  return (
    <div className="event-card-detail">
      {icon}
      <span>{text}</span>
    </div>
  );
}

//---------------------EVENT-CARD-BUTTON-------------------
export function EventCardButton({ label, onClick, className }) {
  return (
    <button className={`event-card-button ${className || ''}`} onClick={onClick}>
      <span>{label}</span>
    </button>
  );
}

//---------------------NEXT-BUTTON-------------------
export function CustomButton1({ label, onClick }) {
  return (
    <button className='Button1' onClick={onClick}>
      {label}
    </button>
  );
}

//---------------------NEXT-BUTTON-------------------
export function CustomButton2({ label, onClick, children, disabled }) {
  return (
    <button className='Button2' onClick={onClick} disabled={disabled}> {/* Pass disabled prop here */}
      {label}
      {children}
    </button>
  );
}

//---------------------NEXT-BUTTON-------------------
export function CustomButton3({ label, label2, onClick }) {
  return (
    <button className='Button3' onClick={onClick}>
      <div className="IconContainer">
      <p className='B3text2'>{label2}</p>
      </div>
      <p className='B3text'>{label}</p>
    </button>
  );
 }

 //---------------------NEXT-BUTTON-------------------
 export function CustomButton4({ label, onClick, backgroundImage, backgroundColor, disabled, className = '' }) {
  const buttonStyle = {
    ...(typeof backgroundImage === 'string' && { backgroundImage: `url(${backgroundImage})` }),
    ...(typeof backgroundColor !== 'undefined' && { backgroundColor: backgroundColor })
  };

  return (
    <button className={`Button4 ${disabled ? 'loading' : ''} ${className}`} onClick={onClick} disabled={disabled}>
      <span className="circle" style={buttonStyle}>
        <span className="icon arrow"></span>
      </span>
      <span className="button-text">{label}</span>
    </button>
  );
}

//---------------------NEXT-BUTTON-------------------
export function CustomButton5({ label, onClick, backgroundImage, disabled, className = '' }) {
  const buttonStyle = {
    ...(typeof backgroundImage === 'string' && { backgroundImage: `url(${backgroundImage})` }),
  };

  return (
    <button 
      className={`Button5 ${disabled ? 'loading' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={buttonStyle}
    >
      <span className='sp1'>{label}</span>
      <span className='sp2'></span>
    </button>
  );
}

//---------------------NEXT-BUTTON-------------------
export function CustomButton6({ label, onClick,}) {
  return (
    <button className='Button6' onClick={onClick}>
      <div className='Button6-ins'>
        <span className='sp6'>
          {label}
        </span>
      </div>
    </button>
  );
}

//---------------------NEXT-BUTTON-------------------
export function CustomButton7({children, label, onClick }) {
  return (
    <button className='Button7' onClick={onClick}>
      {label}
      <div className='Button7-ch'>{children}</div>
    </button>
  );
}
//---------------------NEXT-BUTTON-------------------
export function CustomButton8({ children, label, onClick }) {
  return (
    <button className='Button8' onClick={onClick}>
      {label}
      {children}
    </button>
  );
}
//---------------------NEXT-BUTTON-------------------
export default function CustomButton9({ label, onClick, children }) {
  return (
    <button className="button9 noselect" onClick={onClick}>
      <span className="text">{label}</span>
      <span className="icon">
        {children}
      </span>
    </button>
  );
}
//---------------------NEXT-BUTTON-------------------
export function CustomButton10({ label, onClick, children, disabled }) {
  return (
    <button className='Button10' onClick={onClick} disabled={disabled}>
      {label}
      {children}
    </button>
  );
}
//---------------------NEXT-BUTTON-------------------
export function CustomButton10Ca({ label, onClick, children, disabled }) {
  return (
    <button className='Button10Ca' onClick={onClick} disabled={disabled}>
      {label}
      {children}
    </button>
  );
}
//---------------------NEXT-BUTTON-------------------
export function CustomButton10Co({ label, onClick, children, disabled }) {
  return (
    <button className='Button10Co' onClick={onClick} disabled={disabled}>
      {label}
      {children}
    </button>
  );
}
//---------------------NEXT-BUTTON-------------------
export function CustomButton11({ label, onClick, children, disabled }) {
  return (
    <button className='Button11' onClick={onClick} disabled={disabled}> {/* Pass disabled prop here */}
      {label}
      {children}
    </button>
  );
}
//---------------------NEXT-BUTTON-------------------

//===================== NEW BUTTON SYSTEM (design-review/REDESIGN_SPEC.md §14) =====================
// One canonical button. variant: primary | secondary | tertiary | destructive. size: sm | md | lg.
export function Button({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  icon = null,
  iconPosition = 'left',
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  ...rest
}) {
  const isDisabled = disabled || loading;
  return (
    <button
      type={type}
      className={`bk-btn bk-btn--${variant} bk-btn--${size}${loading ? ' bk-btn--loading' : ''}${className ? ' ' + className : ''}`}
      onClick={onClick}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <span className="bk-btn__spinner" aria-hidden="true" />}
      {icon && iconPosition === 'left' && <span className="bk-btn__icon">{icon}</span>}
      {children && <span className="bk-btn__label">{children}</span>}
      {icon && iconPosition === 'right' && <span className="bk-btn__icon">{icon}</span>}
    </button>
  );
}

// One circular icon button. size: sm(32) | md(40) | lg(48). variant: ghost | filled | glass.
export function IconButton({
  icon,
  onClick,
  ariaLabel,
  size = 'md',
  variant = 'ghost',
  disabled = false,
  type = 'button',
  className = '',
  ...rest
}) {
  return (
    <button
      type={type}
      className={`bk-iconbtn bk-iconbtn--${variant} bk-iconbtn--${size}${className ? ' ' + className : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      {...rest}
    >
      {icon}
    </button>
  );
}
//---------------------NEXT-BUTTON-------------------
//---------------------RADIO-BUTTON-------------------
export function RadioButton1({ name, label, value, checked, onChange }) {
  return (
    <label className="RadioButton1">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <span className="RadioButton1-custom" />
      <span className="RadioButton1-label">{label}</span>
    </label>
  );
}


//---------------------NEXT-CHECK-BOX-------------------

export function Checkbox1({ id, label, checked, onChange, onKeyDown }) {
  return (
    <div className='CustomCheckBox1'>
      <input 
        className="inp-cbx" 
        id={id} 
        type="checkbox"
        checked={checked}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
      <label className="cbx" htmlFor={id}>
        <span className='spC1'>
          <svg className='svgC1' width="12px" height="12px">
            <use xlinkHref="#check-4" />
          </svg>
        </span>
        <span className='spC1'>{label}</span>
      </label>
      <svg className="inline-svg">
        <symbol id="check-4" viewBox="0 0 12 10">
          <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
        </symbol>
      </svg>
    </div>
  );
}

//---------------------NEXT-INPUT-BOX-------------------

export function InputName1({ id, label, value, onChange }) {
  const hasValue = value && value.length > 0;

  return (
    <div className={`CustomInput1 ${hasValue ? 'has-value' : ''}`}>
      <input
        className='CI1'
        type="text"
        id={id}
        value={value}
        onChange={onChange}
        required
        autoComplete="off"
      />
      <label className='CL1' htmlFor={id}>{label}</label>
    </div>
  );
}

//---------------------NEXT-INPUT-BOX-------------------
export function InputPassword1({ id, label, value, onChange, disabled }) {
  // For the settings form, we might not have a label directly in this component
  const showInternalLabel = label !== undefined;
  
  return (
    <div className='CustomInput11'>
      <input
        className='CI11'
        type="password"
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required
        autoComplete="new-password"
      />
      {showInternalLabel && <label className='CL11' htmlFor={id}>{label}</label>}
    </div>
  );
}

//---------------------NEXT-INPUT-BOX-------------------
export function CustomInputBox1({ placeholder, value, onChange, children, name, type = 'text', maxLength, error, min, max, required = false, disabled = false }) {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className={`CustomInputBox1 ${isFocused || value ? 'focused' : ''} ${error ? 'error' : ''}`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
      {children}
      <input
        className='CustomInput2'
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
        min={min}
        max={max}
      />
      </div>
    </div>
  );
}
//---------------------NEXT-INPUT-BOX-------------------
export function CustomTextArea({ placeholder, value, onChange, maxLength, rows = 3, disabled = false }) {
  const [isFocused, setIsFocused] = useState(false);
  const [charCount, setCharCount] = useState(value ? value.length : 0);
  const textareaRef = useRef(null);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleChange = (e) => {
    setCharCount(e.target.value.length);
    onChange(e);
    
    // Auto-resize functionality
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  // Auto-resize on mount if there's initial value
  useEffect(() => {
    if (textareaRef.current && value) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <div className={`custom-textarea-container ${isFocused || value ? 'focused' : ''} ${disabled ? 'disabled' : ''}`}>
      <textarea
        ref={textareaRef}
        className='custom-textarea'
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={rows}
        disabled={disabled}
        style={{ resize: 'none', overflow: 'hidden' }}
      />
      {maxLength && (
        <div className="char-counter">
          <span className={charCount > maxLength * 0.8 ? charCount > maxLength * 0.95 ? 'near-limit' : 'approaching-limit' : ''}>
            {charCount}
          </span>
          <span>/</span>
          <span>{maxLength}</span>
        </div>
      )}
    </div>
  );
}

//---------------------NEXT-INPUT-BOX-------------------
export function CustomInputBox2({ placeholder, value, onChange, children, onKeyDown }) {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className={`CustomInputBox2 ${isFocused || value ? 'focused' : ''}`}>
      <div className='CI2-ins'>
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
        {children}
        <input
          className='CustomInput22'
          type="text"
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={onKeyDown}
          required
          placeholder={placeholder}
        />
        </div>
      </div>
    </div>
  );
}
//---------------------NEXT-INPUT-BOX-------------------


//---------------------TOAST STYLE1-------------------
// In Templates.js, make sure these exports are present

export const Toast = ({ type, title, description, onClose }) => {
  const [isExiting, setIsExiting] = useState(false);
  const toastRef = useRef(null);

  // Handle auto-close with timer
  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 4700); // Slightly less than CSS animation time

    return () => clearTimeout(timer);
  }, []);

  // Handle manual close with transition
  const handleClose = () => {
    // Set exiting state to trigger CSS transition
    setIsExiting(true);
    
    // Wait for transition to complete before actual removal
    setTimeout(() => {
      if (onClose) onClose();
    }, 300); // Match transition duration in CSS
  };

  // Pause animation on hover
  const handleMouseEnter = () => {
    if (toastRef.current) {
      toastRef.current.style.animationPlayState = 'paused';
      
      // Also pause progress bar animation
      const progressBar = toastRef.current.querySelector('.progress');
      if (progressBar) {
        progressBar.style.animationPlayState = 'paused';
      }
    }
  };

  // Resume animation on mouse leave
  const handleMouseLeave = () => {
    if (toastRef.current) {
      toastRef.current.style.animationPlayState = 'running';
      
      // Also resume progress bar animation
      const progressBar = toastRef.current.querySelector('.progress');
      if (progressBar) {
        progressBar.style.animationPlayState = 'running';
      }
    }
  };

  return (
    <div
      ref={toastRef}
      className={`toast-notification ${type} ${isExiting ? 'toast-exit' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      role={type === 'error' ? 'alert' : 'status'}
    >
      <div className="toast-notification-content">
        <div className="toast-notification-title">{title}</div>
        {description && (
          <div className="toast-notification-description">{description}</div>
        )}
      </div>
      <button className="toast-notification-close" onClick={handleClose}>
        <FaTimes />
      </button>
      <div className="progress"></div>
    </div>
  );
};

// Updated ToastContainer component
export const ToastContainer = () => {
  const { toasts, removeToast } = useToast();
  
  if (!toasts.length) return null;
  
  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          {...toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

//---------------------DATETIME PICKER COMPONENTS-------------------
export function DateTimePickerContainer({ children }) {
  return (
    <div className="Templates-datetime-container">
      {children}
    </div>
  );
}

export const DatePickerWrapper = React.forwardRef(({ icon, children, disabled = false }, ref) => {
  return (
    <div ref={ref} className={`Templates-date-picker-wrapper ${disabled ? 'disabled' : ''}`}>
      <div className="icon">
        {icon}
      </div>
      {children}
    </div>
  );
});

export const TimePickerWrapper = React.forwardRef(({ icon, children, disabled = false }, ref) => {
  return (
    <div ref={ref} className={`Templates-time-picker-wrapper ${disabled ? 'disabled' : ''}`}>
      <div className="icon">
        {icon}
      </div>
      {children}
    </div>
  );
});

//---------------------MODERN FORM SECTION-------------------
export function ModernFormSection({ icon, title, children, className = '' }) {
  return (
    <section className={`form-section ${className}`}>
      <h3>
        {icon && <span className="section-icon">{icon}</span>}
        {title}
      </h3>
      {children}
    </section>
  );
}

//---------------------MODERN CARD CONTAINER-------------------
export function ModernCard({ children, className = '', hover = true }) {
  return (
    <div className={`modern-card ${className} ${hover ? 'hoverable' : ''}`}>
      {children}
    </div>
  );
}

//---------------------MODERN DROPDOWN-------------------
export function ModernDropdown({ 
  label, 
  value, 
  options, 
  onSelect, 
  icon, 
  placeholder = 'Select option', 
  disabled = false,
  className = '' 
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`modern-dropdown ${className} ${isOpen ? 'open' : ''}`} ref={dropdownRef}>
      {label && (
        <h4 className="dropdown-label">
          {icon && <span className="label-icon">{icon}</span>}
          {label}
        </h4>
      )}
      <div className="dropdown-control">
        <button 
          type="button"
          className="modern-dropdown-button"
          onClick={() => !disabled && setIsOpen(!isOpen)}
          disabled={disabled}
        >
          <span>{value || placeholder}</span>
          <FaAngleDown className={`dropdown-arrow ${isOpen ? 'open' : ''}`} />
        </button>
        
        {isOpen && (
          <ul className="dropdown-list">
            {options.map((option, index) => (
              <li 
                key={index}
                className={value === option ? 'active' : ''}
                onClick={() => {
                  onSelect(option);
                  setIsOpen(false);
                }}
              >
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

//---------------------MODERN SWITCH-------------------
export function ModernSwitch({ 
  label, 
  checked, 
  onChange, 
  leftIcon, 
  rightIcon, 
  disabled = false,
  className = '' 
}) {
  return (
    <label className={`modern-switch ${className} ${disabled ? 'disabled' : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <div className="slider">
        <span className="slider-icon">
          {checked ? rightIcon : leftIcon}
        </span>
      </div>
      <span className="switch-label">{label}</span>
    </label>
  );
}

//---------------------MODERN DATE TIME PICKER-------------------
// Updated ModernDateTimePicker to use the unified component
export function ModernDateTimePicker({ 
  dateValue, 
  timeValue, 
  onDateChange, 
  onTimeChange, 
  disabled = false 
}) {
  return (
    <UnifiedDateTimePicker
      dateValue={dateValue}
      timeValue={timeValue}
      onDateChange={onDateChange}
      onTimeChange={onTimeChange}
      disabled={disabled}
      theme="default"
    />
  );
}


export function AddStopButton({ onClick, disabled = false, children, text = 'Add' }) {
  return (
    <button 
      className={`add-stop-button ${disabled ? 'disabled' : ''}`} 
      onClick={onClick}
      disabled={disabled}
    >
      <span className="add-stop-icon">
        {children}
      </span>
      <span className="add-stop-text">{text}</span>
      <div className="add-stop-hover-effect"></div>
    </button>
  );
}

//---------------------NAVIGATION BUTTONS FOR TOOLTIPS/CAROUSELS-------------------
export function NavButton({ direction, onClick, disabled = false, className = '', title, children }) {
  return (
    <button 
      className={`nav-button ${direction} ${disabled ? 'disabled' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {children}
    </button>
  );
}

//---------------------REFRESH BUTTON-------------------
export function RefreshButton({ onClick, disabled = false, tooltip, className = '', size = 'medium' }) {
  return (
    <button 
      className={`refresh-button ${size} ${disabled ? 'disabled' : ''} ${className}`}
      onClick={onClick}
      disabled={disabled}
      title={tooltip}
    >
      <FaSyncAlt className={`refresh-icon ${disabled ? 'spinning' : ''}`} />
    </button>
  );
}

export function NavigationContainer({ currentPage, totalPages, onPrevClick, onNextClick, disabled = false, className = '', compact = false, showDots = false }) {
  const containerClass = `navigation-container ${compact ? 'compact' : ''} ${className}`;
  
  return (
    <div className={containerClass}>
      <NavButton 
        direction="prev"
        onClick={onPrevClick}
        disabled={disabled || currentPage === 0}
        title="Previous page (or swipe right)"
      >
        <FaChevronLeft />
      </NavButton>
      
      {showDots ? (
        <div className="page-indicators">
          {Array.from({ length: totalPages }, (_, index) => (
            <FaCircle 
              key={index}
              className={`indicator ${currentPage === index ? 'active' : ''}`} 
            />
          ))}
        </div>
      ) : (
        <div className="page-info">
          <span className="page-number">{currentPage + 1}</span>
          <span className="page-divider">/</span>
          <span className="total-pages">{totalPages}</span>
        </div>
      )}
      
      <NavButton 
        direction="next"
        onClick={onNextClick}
        disabled={disabled || currentPage === totalPages - 1}
        title="Next page (or swipe left)"
      >
        <FaChevronRight />
      </NavButton>
    </div>
  );
}

//---------------------INLINE THEME SELECTOR-------------------
export function InlineThemeSelector() {
  const { t } = useTranslation('common');
  const { userProfile, updateThemePreference } = useContext(AuthContext);
  const [isExpanded, setIsExpanded] = useState(false);

  // SIMPLIFIED: Just track selection, don't apply theme (Provider handles that)
  const [selectedOption, setSelectedOption] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    console.log('InlineThemeSelector initialized with theme:', savedTheme || 'option1');
    return savedTheme || 'option1';
  });

  const handleThemeChange = (option) => {
    console.log('User selected theme:', option);
    setSelectedOption(option);
    if (updateThemePreference) {
      updateThemePreference(option);
    }
    // Close the theme selector after selecting a theme
    setIsExpanded(false);
  };

  const toggleThemeSelector = () => {
    setIsExpanded(!isExpanded);
  };

  // Get the current theme name for display
  const getCurrentThemeName = () => {
    switch(selectedOption) {
      case 'option1':
        return t('menu.theme_default');
      case 'option2':
        return t('menu.theme_dark');
      case 'option3':
        return t('menu.theme_light');
      default:
        return t('menu.theme_default');
    }
  };

  return (
    <div className="inline-theme-selector">
      <button
        className="theme-toggle-button"
        onClick={toggleThemeSelector}
        type="button"
      >
        <FaPalette className="theme-icon" />
        <span className="theme-current">{getCurrentThemeName()}</span>
        {isExpanded ? <FaChevronUp className="chevron-icon" /> : <FaChevronDown className="chevron-icon" />}
      </button>

      {isExpanded && (
        <div className="theme-option-group">
          <label className="theme-option">
            <input
              type="radio"
              name="theme"
              value="option1"
              checked={selectedOption === 'option1'}
              onChange={() => handleThemeChange('option1')}
            />
            <span className="theme-label">{t('menu.theme_default')}</span>
          </label>
          <label className="theme-option">
            <input
              type="radio"
              name="theme"
              value="option2"
              checked={selectedOption === 'option2'}
              onChange={() => handleThemeChange('option2')}
            />
            <span className="theme-label">{t('menu.theme_dark')}</span>
          </label>
          <label className="theme-option">
            <input
              type="radio"
              name="theme"
              value="option3"
              checked={selectedOption === 'option3'}
              onChange={() => handleThemeChange('option3')}
            />
            <span className="theme-label">{t('menu.theme_light')}</span>
          </label>
        </div>
      )}
    </div>
  );
}

//---------------------CLOSE BUTTONS-------------------
export function CloseButton1({ onClick, className = '', size = 'medium' }) {
  return (
    <button
      className={`close-button-1 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Close"
    >
      <FaTimes />
    </button>
  );
}

export function CloseButton2({ onClick, className = '', size = 'medium' }) {
  return (
    <button
      className={`close-button-2 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Close"
    >
      <span className="close-line-1"></span>
      <span className="close-line-2"></span>
    </button>
  );
}

export function CloseButton3({ onClick, className = '', size = 'medium' }) {
  return (
    <button
      className={`close-button-3 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Close"
    >
      <div className="close-icon-wrapper">
        <FaTimes />
      </div>
    </button>
  );
}

//---------------------SEARCH BUTTONS-------------------
export function SearchButton1({ onClick, className = '', size = 'medium' }) {
  return (
    <button
      className={`search-btn-1 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Search"
    >
      <svg className="search-icon-1" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
        <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </button>
  );
}

export function SearchButton2({ onClick, className = '', size = 'medium' }) {
  return (
    <button
      className={`search-btn-2 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Search"
    >
      <svg className="search-icon-2" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
        <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </button>
  );
}

export function SearchButton3({ onClick, className = '', size = 'medium' }) {
  const { t } = useTranslation('common');

  return (
    <button
      className={`search-btn-3 ${size} ${className}`}
      onClick={onClick}
      type="button"
    >
      <svg className="search-icon-3" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
        <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
      <span className="search-text-3">{t('search')}</span>
    </button>
  );
}

export function SearchButton4({ onClick, className = '', size = 'medium' }) {
  const { t } = useTranslation('common');

  return (
    <button
      className={`search-btn-4 ${size} ${className}`}
      onClick={onClick}
      type="button"
    >
      <svg className="search-icon-4" viewBox="0 0 24 24" fill="none">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
        <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
      <span className="search-text-4">{t('search')}</span>
    </button>
  );
}

//---------------------BACK BUTTONS-------------------
export function BackButton1({ onClick, className = '', size = 'medium' }) {
  return (
    <button
      className={`back-btn-1 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Go back"
    >
      <svg className="back-icon-1" viewBox="0 0 24 24" fill="none">
        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
}

export function BackButton2({ onClick, className = '', size = 'medium', label }) {
  const { t } = useTranslation('common');

  return (
    <button
      className={`back-btn-2 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Go back"
    >
      <svg className="back-icon-2" viewBox="0 0 24 24" fill="none">
        <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      {label && <span className="back-text-2">{label}</span>}
      {!label && <span className="back-text-2">{t('buttons.back') || 'Back'}</span>}
    </button>
  );
}

export function BackButton3({ onClick, className = '', size = 'medium' }) {
  return (
    <button
      className={`back-btn-3 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Go back"
    >
      <div className="back-icon-wrapper-3">
        <FaArrowLeft />
      </div>
    </button>
  );
}

export function BackButton4({ onClick, className = '', size = 'medium', label }) {
  const { t } = useTranslation('common');

  return (
    <button
      className={`back-btn-4 ${size} ${className}`}
      onClick={onClick}
      type="button"
      aria-label="Go back"
    >
      <div className="back-content-4">
        <FaChevronLeft className="back-chevron-4" />
        {label && <span className="back-text-4">{label}</span>}
        {!label && <span className="back-text-4">{t('buttons.back') || 'Back'}</span>}
      </div>
    </button>
  );
}

//---------------------CHAT INPUT-------------------
export function ChatInput({ value, onChange, onSend, placeholder = 'Type a message...', disabled = false, maxLength = 2000 }) {
  const textareaRef = useRef(null);
  const [rows, setRows] = useState(1);

  useEffect(() => {
    if (textareaRef.current) {
      // Reset height to auto to get the correct scrollHeight
      textareaRef.current.style.height = 'auto';

      const scrollHeight = textareaRef.current.scrollHeight;
      const lineHeight = 24; // approximate line height in pixels
      const maxHeight = lineHeight * 3; // 3 lines max before scrolling

      if (scrollHeight <= maxHeight) {
        textareaRef.current.style.height = `${scrollHeight}px`;
        textareaRef.current.style.overflowY = 'hidden';
        setRows(Math.min(3, Math.ceil(scrollHeight / lineHeight)));
      } else {
        textareaRef.current.style.height = `${maxHeight}px`;
        textareaRef.current.style.overflowY = 'auto';
        setRows(3);
      }
    }
  }, [value]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (value.trim() && onSend) {
        onSend();
      }
    }
  };

  return (
    <div className="chat-input-container">
      <textarea
        ref={textareaRef}
        className="chat-input-textarea"
        value={value}
        onChange={onChange}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        rows={1}
      />
      <button
        className={`chat-send-button ${value.trim() ? 'active' : ''}`}
        onClick={onSend}
        disabled={disabled || !value.trim()}
        type="button"
      >
        <svg className="send-icon" viewBox="0 0 24 24" fill="none">
          <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
}